import { render, staticRenderFns } from "./CircleWithInitialsInbox.vue?vue&type=template&id=70b980f2&scoped=true"
import script from "./CircleWithInitialsInbox.vue?vue&type=script&lang=ts"
export * from "./CircleWithInitialsInbox.vue?vue&type=script&lang=ts"
import style0 from "./CircleWithInitialsInbox.vue?vue&type=style&index=0&id=70b980f2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b980f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b980f2')) {
      api.createRecord('70b980f2', component.options)
    } else {
      api.reload('70b980f2', component.options)
    }
    module.hot.accept("./CircleWithInitialsInbox.vue?vue&type=template&id=70b980f2&scoped=true", function () {
      api.rerender('70b980f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CircleWithInitialsInbox.vue"
export default component.exports